// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Sensor Info plugin styles. The menu uses the shared v13 card system
 * (.kt-ui-v13 + kt-section/kt-action/...); see src/engine/ui/menu-v13.css.
 * Only the read-only sensor name banner and the key/value detail rows need
 * plugin-specific chrome.
 */

/* Sensor name banner above the detail cards (replaces the old center <h5>,
 * which the side-menu pipeline strips). Updated at runtime by sensorManager. */
#sensor-info-menu .sensor-info-name {
  margin: 0 6px 12px;
  font-size: 16px;
  font-weight: 700;
  text-align: center;
  color: var(--color-text-light, #f5f5f5);
}

#sensor-info-menu .sensor-info-name a {
  color: var(--color-text-light, #f5f5f5) !important;
}

/* Tighten the key/value detail rows inside the v13 card (the global
 * \`.sensor-info-row\` margin of 10px is too loose for the inset card). */
#sensor-info-menu .kt-section .sensor-info-row {
  margin: 0;
  padding: 6px 0;
  text-align: left;
  height: auto;
}

#sensor-info-menu .kt-section .sensor-info-row + .sensor-info-row {
  border-top: 1px solid var(--color-dark-border);
}

#sensor-info-menu .kt-section .sensor-info-key {
  float: none;
  color: var(--color-dark-text-muted);
}

#sensor-info-menu .kt-section .sensor-info-value {
  float: right;
  color: var(--color-text-light, #f5f5f5);
}
`, "",{"version":3,"sources":["webpack://./src/plugins/sensor/sensor-info.css"],"names":[],"mappings":"AAAA;;;;;EAKE;;AAEF;+EAC+E;AAC/E;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;wEACwE;AACxE;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,uCAAuC;AACzC","sourcesContent":["/*\n * Sensor Info plugin styles. The menu uses the shared v13 card system\n * (.kt-ui-v13 + kt-section/kt-action/...); see src/engine/ui/menu-v13.css.\n * Only the read-only sensor name banner and the key/value detail rows need\n * plugin-specific chrome.\n */\n\n/* Sensor name banner above the detail cards (replaces the old center <h5>,\n * which the side-menu pipeline strips). Updated at runtime by sensorManager. */\n#sensor-info-menu .sensor-info-name {\n  margin: 0 6px 12px;\n  font-size: 16px;\n  font-weight: 700;\n  text-align: center;\n  color: var(--color-text-light, #f5f5f5);\n}\n\n#sensor-info-menu .sensor-info-name a {\n  color: var(--color-text-light, #f5f5f5) !important;\n}\n\n/* Tighten the key/value detail rows inside the v13 card (the global\n * `.sensor-info-row` margin of 10px is too loose for the inset card). */\n#sensor-info-menu .kt-section .sensor-info-row {\n  margin: 0;\n  padding: 6px 0;\n  text-align: left;\n  height: auto;\n}\n\n#sensor-info-menu .kt-section .sensor-info-row + .sensor-info-row {\n  border-top: 1px solid var(--color-dark-border);\n}\n\n#sensor-info-menu .kt-section .sensor-info-key {\n  float: none;\n  color: var(--color-dark-text-muted);\n}\n\n#sensor-info-menu .kt-section .sensor-info-value {\n  float: right;\n  color: var(--color-text-light, #f5f5f5);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
